import { apiClient } from './client';

export type AuditFrequency = 'off' | 'daily' | 'weekly' | 'monthly';

export interface AuditSchedule {
  frequency: AuditFrequency;
  frequency_label: string;
  is_enabled: boolean;
  audit_types: string[] | null;
  timezone: string;
  run_at_hour: number;
  next_run_at: string | null;
  last_run_at: string | null;
}

export interface UpsertSchedulePayload {
  frequency: AuditFrequency;
  audit_types?: string[] | null;
  run_at_hour?: number;
  timezone?: string;
}

export async function getAuditSchedule(): Promise<AuditSchedule> {
  const res = await apiClient.get<{ data: AuditSchedule }>('/audit-schedule');
  return res.data.data;
}

export async function upsertAuditSchedule(payload: UpsertSchedulePayload): Promise<AuditSchedule> {
  const res = await apiClient.put<{ data: AuditSchedule }>('/audit-schedule', payload);
  return res.data.data;
}

export async function deleteAuditSchedule(): Promise<AuditSchedule> {
  const res = await apiClient.delete<{ data: AuditSchedule }>('/audit-schedule');
  return res.data.data;
}
